import instance from '../axios';

export const addLineItem = (idComprobation, lineItemData) => {
  return instance.post(`/po/${idComprobation}/addLine`, lineItemData);
};

export const removeLineItem = (idLineItem) => {
  return instance.delete(`/po/line/${idLineItem}`);
};
